import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Version from "../views/Version.vue"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/version',
        name: 'Version',
        component: Version
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
